import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { Alert } from 'react-bootstrap'
import { getNflScoreboard } from '@severed-links/common.redherrings-reducers/football'
import { find } from 'lodash'
import NFLScoreboardGameDay from './NFLScoreboardGameDay'
import SeasonSelector from '../../SeasonSelector'
import WeekSelector from '../../WeekSelector'
import * as s from './NFLScoreboard.scss'
import { getFootballUrlParams } from '@severed-links/common.redherrings-constants'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'

const NFLScoreboard = ({ }) => {

    const dispatch = useDispatch()
    const params = useParams()
    const seasons = useSelector(state => state.football.seasons)
    const nflScoreboards = useSelector(state => state.football.nflScoreboards)
    const c = getFootballUrlParams(params, seasons)
    const sb = find(nflScoreboards, x => c.season && x.seasonId === c.season.seasonId && Number(x.weekNumber) === c.week)
    const [isLoading, setLoading] = useState(true)
    const [loadError, setLoadError] = useState(false)

    useEffect(() => {
        if (!c.seasonId || !c.week) return undefined
        let isCurrentRequest = true
        setLoading(true)
        setLoadError(false)
        const load = async () => {
            try {
                const action = await dispatch(getNflScoreboard(c.seasonId, `${c.isPlayoffWeek ? 'PW' : 'W'}${c.week}`))
                if (isCurrentRequest) setLoadError(Boolean(action.error))
            } catch {
                if (isCurrentRequest) setLoadError(true)
            }
              if (isCurrentRequest) setLoading(false)
        }
        load()
        return () => { isCurrentRequest = false }
    }, [dispatch, c.seasonId, c.week, c.isPlayoffWeek])

    return (
        <div className={s.container}>
            <div className={s.hero}>
                <div className={s.heroIcon}><FontAwesomeIcon name='shield-alt' /></div>
                <div className={s.heroBody}>
                    <div className={s.eyebrow}>NFL</div>
                    <h2 className={s.title}>Scoreboard</h2>
                    <div className={s.subtitle}>{sb?.seasonName || c.seasonName} · {sb?.weekDisplay || `${c.isPlayoffWeek ? 'Playoff Week' : 'Week'} ${c.week}`}</div>
                </div>
                <div className={s.controls}>
                    <div className={s.seasonSelector}><SeasonSelector seasons={seasons} season={c.season} /></div>
                    <div className={s.weekSelector}><WeekSelector seasons={seasons} season={c.season} week={`${c.isPlayoffWeek ? 'PW' : 'W'}${c.week}`} /></div>
                </div>
            </div>
            <div className={s.gamesContainer}>
            {isLoading && !sb ? <Alert variant='info'>Loading NFL scoreboard…</Alert> : null}
            {loadError && !sb ? <Alert variant='danger'>The NFL scoreboard could not be loaded. Please try again.</Alert> : null}
            {!isLoading && !loadError && sb && (!sb.gameDays || !sb.gameDays.length) ? <Alert variant='info'>No NFL games are scheduled for this week.</Alert> : null}
            {sb?.gameDays && sb.gameDays.map((d, index) =>
                <NFLScoreboardGameDay gameDay={d} seasonId={sb.seasonId} seasonName={sb.seasonName} seasonMode={sb.seasonMode} week={sb.weekNumber} showLines
                    key={`nfl-scoreboard-${sb.seasonId}-week-${sb.weekNumber}-day-${d.gameDate}`} />
            )}
            </div>
        </div>
    )
}

export default NFLScoreboard
